/**
 * Perpetual DEX contract addresses
 *
 * This file now imports from the centralized chain config.
 * All chain data is managed in src/config/chains/
 */
import {
  CHAIN_CONFIGS,
  getUsdcDecimals as getCentralizedUsdcDecimals,
  getPerpetualDexAddresses,
} from "../../config/chains";
import { ChainIdEnum } from "../../enums/chain";
import { PerpetualDexContracts } from "../../types/perpetual-dex";

/**
 * PERPETUAL_DEX_ADDRESSES - now derived from centralized CHAIN_CONFIGS
 * Maintained for backwards compatibility
 */
export const PERPETUAL_DEX_ADDRESSES: Record<
  ChainIdEnum,
  PerpetualDexContracts | undefined
> = Object.fromEntries(
  Array.from(CHAIN_CONFIGS.entries()).map(([chainId, config]) => [
    chainId,
    config.contracts.perpetualDex,
  ])
) as Record<ChainIdEnum, PerpetualDexContracts | undefined>;

/**
 * Get perpetual DEX contracts for a chain
 * Now uses centralized config
 */
export const getPerpetualDexContracts = (
  chainId?: ChainIdEnum
): PerpetualDexContracts | undefined => {
  if (!chainId) return undefined;
  return getPerpetualDexAddresses(chainId);
};

/**
 * Get market address for a specific market on a chain
 */
export const getMarketAddress = (
  chainId: ChainIdEnum,
  marketName: string
): string | undefined => {
  const contracts = getPerpetualDexContracts(chainId);
  return contracts?.markets[marketName];
};

/**
 * Get USDC decimals
 * Now uses centralized config
 */
export const getUsdcDecimals = (): number => {
  return getCentralizedUsdcDecimals();
};
